import { render, staticRenderFns } from "./xdfpage.vue?vue&type=template&id=5379cac4&scoped=true&"
import script from "./xdfpage.vue?vue&type=script&lang=js&"
export * from "./xdfpage.vue?vue&type=script&lang=js&"
import style0 from "./xdfpage.vue?vue&type=style&index=0&id=5379cac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5379cac4",
  null
  
)

export default component.exports